import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';
import { ConfigService } from '../config/config.service';

/**
* A moment timezone pipe to support parsing based on time zone abbreviations
* covers all cases of offset variation due to daylight saving.
*
* Same API as DatePipe with additional timezone abbreviation support
* Official date pipe dropped support for abbreviations names from Angular V5
*/
@Pipe({
    name: 'momentDate',
    pure: false
})
export class MomentDatePipe extends DatePipe implements PipeTransform {
    defaultTimeZone: string;
    constructor(private config: ConfigService) {
        super(config.get('locale'));
        this.defaultTimeZone = this.config.get('defaultTimeZone');
    }

    // Overloads to match DatePipe
    transform(value: null, format?: string, timezone?: string, locale?: string, isDuration?: boolean): null;
    transform(value: string | number | Date, format?: string, timezone?: string, locale?: string, isDuration?: boolean): string;
    transform(
        value: string | number | Date | null,
        format: string = 'mediumDate',
        timezone: string = this.defaultTimeZone, // 'GMT'
        locale: string = this.config.get('locale'),
        isDuration: boolean = false
    ): string | null {
        if (value == null) return null;
        const timezoneOffset = moment(value).tz(timezone).format('Z');
        const base = super.transform(value, format, timezoneOffset);
        if (this.config.isLfp() && format.includes('HH:mm') && !isDuration) {
            return base ? base + " CET" : null;
        }
        return base;
    }
}
